import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { ConfigurationAutomaticAssignmentAlgorithmResponse } from '@/modules/configurationModule/detail/automation/personnel/algorithms-definition/services/configuration-automatic-assignment-algorithm/configuration-automatic-assignment-algorithm.dto'

@Component
export default class ConfigurationAutomationPersonnelAlgorithmsDefinitionModalBasicForm extends Vue {
    @Prop(String) readonly actionTitle!: string
    @Prop() readonly automaticAssignmentAlgorithm!: Partial<ConfigurationAutomaticAssignmentAlgorithmResponse>

    @Emit()
    create(): void {}

    @Emit()
    update(): void {}

    get updateMode(): boolean {
        return !!this.automaticAssignmentAlgorithm?.id
    }

    get modelValidated(): boolean {
        const hasErrors: boolean = this.$validator.errors.any()
        const isDirty: boolean = this.$_someFieldIsDirty(this.fields)
        return !hasErrors && isDirty
    }

    async doAction(): Promise<void> {
        const valid = await this.$validator.validateAll()
        if (valid) {
            if (this.updateMode) {
                this.update() // emits an event
            } else {
                this.create() // emits an event
            }
        }
    }
}
